'use client'

import { useEffect, useRef, useState } from 'react'
import { formatCount } from '@/lib/format-count'

export function Counter({ to, suffix = '' }: { to: number; suffix?: string }) {
  const ref = useRef<HTMLSpanElement>(null)
  const [text, setText] = useState(() => formatCount(to, 0, suffix))

  useEffect(() => {
    const el = ref.current
    if (!el) return
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    let rafId = 0
    const io = new IntersectionObserver(
      (entries) => {
        if (!entries[0]?.isIntersecting) return
        io.unobserve(el)
        if (reduce) {
          setText(formatCount(to, 1, suffix))
          return
        }
        let start: number | null = null
        const tick = (ts: number) => {
          if (start === null) start = ts
          const progress = Math.min((ts - start) / 1300, 1)
          setText(formatCount(to, progress, suffix))
          if (progress < 1) rafId = requestAnimationFrame(tick)
        }
        rafId = requestAnimationFrame(tick)
      },
      { threshold: 0.6 },
    )
    io.observe(el)
    return () => {
      io.disconnect()
      cancelAnimationFrame(rafId)
    }
  }, [to, suffix])

  return (
    <span ref={ref} data-count={to}>
      {text}
    </span>
  )
}
